import { useCallback } from 'react';

type StandardEvent =
  | 'PageView'
  | 'Contact'
  | 'CompleteRegistration'
  | 'Search'
  | 'AddToCart'
  | 'AddToWishlist'
  | 'InitiateCheckout'
  | 'AddPaymentInfo'
  | 'Purchase'
  | 'Lead';

export const useMetaPixel = () => {
  const trackEvent = useCallback(
    (eventName: StandardEvent | string, options?: object) => {
      if (typeof window.fbq === 'function') {
        const standardEvents: string[] = [
          'PageView',
          'Contact',
          'CompleteRegistration',
          'Search',
          'AddToCart',
          'AddToWishlist',
          'InitiateCheckout',
          'AddPaymentInfo',
          'Purchase',
          'Lead',
        ];

        const isStandard = standardEvents.includes(eventName);
        const trackType = isStandard ? 'track' : 'trackCustom';

        if (options) {
          window.fbq(trackType, eventName, options);
        } else {
          window.fbq(trackType, eventName);
        }
      } else {
        if (process.env.NODE_ENV === 'development') {
          console.info(
            `[Meta Pixel Dev Log] ${eventName}:`,
            options || 'No data',
          );
        }
      }
    },
    [],
  );

  return { trackEvent };
};
